import React from 'react';
import { Link } from 'react-router-dom';

const HomeButton = ({ className = '' }) => {
  return (
    <Link 
      to="/" 
      className={`fixed top-4 left-4 z-50 ${className}`}
      aria-label="Go to homepage"
    >
      <img 
        src="/img/logo.png" 
        alt="KaydSystems Logo" 
        className="h-14 w-auto hover:opacity-80 transition-opacity brightness-200"
        />
    </Link>
  );
};

export default HomeButton;